// События аналитики от клиента: копятся и уходят пачкой (до 20) раз в 5 с и при уходе со страницы.
// До входа — с id устройства (track_anon), после — от профиля (track).
import { API_URL } from './config.ts';
import { initData, inTelegram } from './telegram.ts';
import { session } from './api.ts';
import { anonId } from './source.ts';

type Ev = { name: string; props?: Record<string, string | number | boolean> };
const queue: Ev[] = [];
let timer: number | undefined;

export function track(name: string, props?: Ev['props']) {
  queue.push({ name, props });
  if (queue.length >= 20) flush();
  else timer ??= window.setTimeout(flush, 5000);
}

export function flush() {
  if (timer) { clearTimeout(timer); timer = undefined; }
  if (!queue.length) return;
  const events = queue.splice(0, 20);
  const signed = inTelegram() || !!session.get();
  const headers: Record<string, string> = { 'content-type': 'application/json' };
  if (inTelegram()) headers['x-init-data'] = initData();
  const s = session.get();
  if (s) headers['x-session'] = s;
  fetch(API_URL, {
    method: 'POST', headers, keepalive: true,
    body: JSON.stringify({ action: signed ? 'track' : 'track_anon', anon_id: anonId(), events }),
  }).catch(() => { /* аналитика не мешает игре */ });
}

addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flush(); });
addEventListener('pagehide', flush);
